export const CONFIRMATION_DIALOG__DELETE_PAGE = 'CONFIRMATION_DIALOG__DELETE_PAGE';
export const CONFIRMATION_DIALOG__DELETE_PAGE_CONTENT = 'CONFIRMATION_DIALOG__DELETE_PAGE_CONTENT';
